document.documentElement.classList.remove('no-js');
setTimeout(function(){ document.querySelectorAll('.glc .glc-rv-in:not(.on)').forEach(function(e){ e.classList.add('on'); }); var tl=document.getElementById('glc-tl'); if(tl) tl.classList.add('on'); }, 2500);
(function(){
  function init(){
  var root=document; if(!document.querySelector('.glc'))return;
  /* Ingredientes: carrusel infinito */
  var ig=document.getElementById('glc-ing');
  if(ig && ig.children.length>1){
    var orig=[].slice.call(ig.children), n=orig.length;
    orig.forEach(function(c){ var a=c.cloneNode(true); a.setAttribute('aria-hidden','true'); a.removeAttribute('data-shopify-editor-block'); ig.appendChild(a); });
    orig.slice().reverse().forEach(function(c){ var a=c.cloneNode(true); a.setAttribute('aria-hidden','true'); a.removeAttribute('data-shopify-editor-block'); ig.insertBefore(a,ig.firstChild); });
    var setW=function(){ return ig.children[n].offsetLeft-ig.children[0].offsetLeft; };
    var step=function(){ return ig.children[1].offsetLeft-ig.children[0].offsetLeft; };
    var jump=function(x){ ig.style.scrollSnapType='none'; ig.scrollLeft=x; void ig.offsetWidth; ig.style.scrollSnapType=''; };
    var home=function(){ jump(setW()); }; home(); window.addEventListener('resize',home);
    var fix=function(){ var w=setW(), x=ig.scrollLeft; if(x<w*0.5)jump(x+w); else if(x>w*1.5)jump(x-w); };
    var tm; ig.addEventListener('scroll',function(){ clearTimeout(tm); tm=setTimeout(fix,140); },{passive:true});
    var il=document.getElementById('glc-ing-l'), ir=document.getElementById('glc-ing-r');
    if(il)il.addEventListener('click',function(){ ig.scrollBy({left:-step(),behavior:'smooth'}); });
    if(ir)ir.addEventListener('click',function(){ ig.scrollBy({left:step(),behavior:'smooth'}); });
  }
  /* Galería */
  var main=document.getElementById('glc-main'), th=document.getElementById('glc-thumbs');
  var btns=th?[].slice.call(th.querySelectorAll('button')):[], cur=0;
  function show(i){ if(!btns.length||!main)return; cur=(i+btns.length)%btns.length; var b=btns[cur];
    main.style.opacity=0; setTimeout(function(){ main.removeAttribute('srcset'); main.src=b.getAttribute('data-src'); main.style.opacity=1; },160);
    btns.forEach(function(x){x.classList.remove('on')}); b.classList.add('on'); }
  var bar=document.getElementById('glc-bar');
  function run(){ if(!bar)return; bar.classList.remove('run'); void bar.offsetWidth; bar.classList.add('run'); }
  if(bar){ bar.addEventListener('animationend',function(){ if(btns.length>1) show(cur+1); }); }
  var _show=show; show=function(i){ _show(i); run(); };
  run();
  btns.forEach(function(b,i){ b.addEventListener('click',function(){show(i)}); });
  var l=root.querySelector('.glc-gal-arr.l'), r=root.querySelector('.glc-gal-arr.r');
  if(l)l.addEventListener('click',function(){show(cur-1)}); if(r)r.addEventListener('click',function(){show(cur+1)});
  var sx=null, gm=root.querySelector('.glc-gal-main');
  if(gm){ gm.addEventListener('touchstart',function(e){sx=e.touches[0].clientX},{passive:true});
    gm.addEventListener('touchend',function(e){ if(sx===null)return; var d=e.changedTouches[0].clientX-sx; if(Math.abs(d)>40)show(cur+(d<0?1:-1)); sx=null; }); }

  /* Revelado al hacer scroll + timeline */
  var els=root.querySelectorAll('.glc .glc-rv-in'), tl=document.getElementById('glc-tl');
  if('IntersectionObserver' in window){
    var io=new IntersectionObserver(function(es){ es.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('on'); io.unobserve(e.target); } }); },{threshold:.12});
    els.forEach(function(el){io.observe(el)}); if(tl)io.observe(tl);
  } else { els.forEach(function(el){el.classList.add('on')}); if(tl)tl.classList.add('on'); }

  /* Contador (se guarda por sesión, no se reinicia al hacer scroll) */
  var t=document.getElementById('glc-timer');
  if(t){ var hrs=parseInt(t.getAttribute('data-hours'),10)||2, end; try{ end=parseInt(sessionStorage.getItem('glc_end'),10); }catch(e){}
    if(!end||end<Date.now()){ end=Date.now()+hrs*3600*1000-1000; try{ sessionStorage.setItem('glc_end',end); }catch(e){} }
    var p=function(n){return (n<10?'0':'')+n};
    var tick=function(){ var s=Math.max(0,Math.floor((end-Date.now())/1000)), v=p(Math.floor(s/3600))+':'+p(Math.floor(s%3600/60))+':'+p(s%60); if(t.textContent!==v)t.textContent=v; };
    tick(); setInterval(tick,1000); }

  /* Barra fija */
  var st=document.getElementById('glc-sticky');
  if(st){ var onS=function(){ var y=window.pageYOffset||document.documentElement.scrollTop; var all=document.querySelectorAll('.glc'), rr=all[all.length-1].getBoundingClientRect();
      var want=(y>600 && rr.bottom>window.innerHeight*0.6); if(st.classList.contains('show')!==want) st.classList.toggle('show', want); };
    window.addEventListener('scroll',onS,{passive:true}); onS(); }
  }
  /* Botones de compra: abren el formulario de Releasit (botón oculto) */
  document.addEventListener('click',function(e){
    var a=e.target&&e.target.closest?e.target.closest('[data-glc-buy]'):null; if(!a)return;
    var h=document.getElementById('glcRsiHost'); var b=h?h.querySelector('button, #rsi_buy_now_button, ._rsi-buy-now-button'):null;
    if(b){ e.preventDefault(); b.click(); }
  });
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',init); else init();
})();
